import React, { FC, useMemo } from 'react'

import { LineLimitTxt } from 'src/components/atoms'
import { CompassRoleTxt } from 'src/components/molecules'

import { isServer } from 'src/libs/helper'
import { Routes } from 'src/routes'
import { ProfileEntity, ProjectAssignUserEntity } from 'src/types'

type Props = {
  user: ProjectAssignUserEntity
  to: 'internal' | 'external'
  profile?: ProfileEntity
  className?: string
}

export const ProjectAssignDetailItem: FC<Props> = ({ user, to, profile, className }) => {
  const userUrl = useMemo(() => {
    if (isServer) {
      return
    }

    const base = window.location.origin
    return to === 'internal'
      ? `${base}${Routes.UserDetail.buildPath({ userId: user.id })}`
      : `${base}${Routes.ExternalUserDetail.buildPath({ userId: user.id })}`
  }, [user, to])

  return (
    <div className={className}>
      <div className="tw-full-justify">
        <a target="_blank" href={userUrl} rel="noreferrer">
          <LineLimitTxt
            maxLineLimit={2}
            className={`tw-underline tw-cursor-pointer ${
              profile?.id === user.id ? 'tw-text-correctGreen-default' : ''
            }`}
          >
            {user.name ?? user.email}
          </LineLimitTxt>
        </a>
        <CompassRoleTxt
          displayName={user.compassRole.displayName}
          className="tw-text-standardText-secondary tw-w-5/12 tw-shrink-0 tw-text-right"
        />
      </div>
    </div>
  )
}
